import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import R from 'ramda'
import CompanyAccountActions, { CompanyAccountRedux, CompanyAccountTypes } from '../Redux/CompanyAccountRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'


const companyAccountCrudObservable = createCRUDObservable({
  mainRedux: CompanyAccountRedux,
  reduxPath: 'companyAccount',
  dataHandlers: {
    get: response => response.data,
  },
})

const createPaymentEpic = (action$, store, { Api }) => (
  action$.ofType(CompanyAccountTypes.createPaymentRequest)
    .mergeMap(({ companyId, payment }) => (
      Observable
        .fromPromise(Api.companyAccount.createPayment(companyId, payment)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              CompanyAccountActions.createPaymentError(response.error),
            ]
          }

          const newDeposit = {
            quantity: 1,
            type: 'Payment',
          }

          if (payment instanceof FormData) {
            newDeposit.total = payment.get('total')
            newDeposit.registered_at = payment.get('date')
            newDeposit.description = 'Depósito a Cuenta'
          } else {
            newDeposit.total = payment.total
            newDeposit.unit_price = payment.total
            newDeposit.description = payment.description
            newDeposit.registered_at = payment.date
          }
          const { data } = response.data
          const page = 1
          const companyId = data.id
          return [
            CompanyAccountActions.getRequest({ companyId, page }),
            CompanyAccountActions.createPaymentSuccess(),
          ]
        })
    ))
)

const deletePaymentEpic = (action$, store, { Api }) => (
  action$.ofType(CompanyAccountTypes.deletePaymentRequest)
    .mergeMap(({ companyId, payment }) => (
      Observable
        .fromPromise(Api.companyAccount.deletePayment(companyId, payment)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              CompanyAccountActions.deletePaymentError(response.error),
              notificationFail(response.error),
            ]
          }

          const newBalance = R.clone(store.getState().companyAccount.get.results.data)
          const chargeIndex = R.findIndex(R.propEq('id', payment))(newBalance.payments)

          if (chargeIndex > -1) {
            newBalance.payments.splice(chargeIndex, 1)
          }
          const page = R.clone(store.getState().companyAccount.get.results.meta.current_page)
          return [
            CompanyAccountActions.deletePaymentSuccess(),
            CompanyAccountActions.getRequest({ companyId, page }),
            notificationSuccess('Pago Borrado Exitosamente'),
          ]
        })
    ))
)

export const companyAccountObservers = Object.assign({}, companyAccountCrudObservable.observers, {
})

export const companyAccountEpic = combineEpics(
  companyAccountCrudObservable.epic,
  createPaymentEpic,
  deletePaymentEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CompanyAccountObservable.js